import { render, staticRenderFns } from "./FreeShippingProducts.vue?vue&type=template&id=2f37dc0d&scoped=true&"
import script from "./FreeShippingProducts.vue?vue&type=script&lang=js&"
export * from "./FreeShippingProducts.vue?vue&type=script&lang=js&"
import style0 from "./FreeShippingProducts.vue?vue&type=style&index=0&id=2f37dc0d&scoped=true&lang=css&"
import style1 from "./FreeShippingProducts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f37dc0d",
  null
  
)

export default component.exports